// client/src/screens/BathroomScreen.js
import React, { useEffect, useState } from 'react';
import '../styles/BathroomScreen.css';

const BathroomScreen = () => {
  const [bathrooms, setBathrooms] = useState([]);

  useEffect(() => {
    // Fetch bathrooms from Firebase
    const fetchBathrooms = async () => {
      // Your Firebase query here
    };
    fetchBathrooms();
  }, []);

  return (
    <div className="bathroom-container">
      <div className="map-container" id="map">
        {/* Map will be rendered here via JS */}
      </div>
      
      <h2>Nearby Bathrooms</h2>
      <div className="bathroom-list">
        {bathrooms.map(bathroom => (
          <div key={bathroom.id} className="bathroom-card">
            <h3>{bathroom.name}</h3>
            <p>{bathroom.distance} miles away</p>
            <button className="book-button">
              Book Now - ${bathroom.price}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BathroomScreen;

